import React from "react";
import "./collection.css";

export function Collection({ assets, onSelect }) {
  return (
    <div className="collection-container">
      {
        assets && assets.length
        ? assets.map(a => (
          <div className="item-container" onClick={() => onSelect(a)}>
            <div style={{ backgroundImage: `url(${encodeURI(a.preview)})` }}>
              <div className="tile-helper overlay">
              <svg viewBox="0 0 960 628"></svg>
              <div className="tile-caption animate">
                <div className="tile-title"></div>
                <div className="tile-subtitle"></div>
              </div>
            </div>
            </div>
          </div>
        ))
        : (
          <h3>There are no assets in the album</h3>
        )
      }
    </div>
  );
}

function BuildItem(asset) {
  if (asset.sources && asset.sources.length) {
    console.log(asset.sources[0].src);
  }
  return (
    <div className="tile-helper overlay">
      <div className="tile-caption animate">
        <div className="tile-title"></div>
        <div className="tile-subtitle"></div>
      </div>
    </div>
  );
}
